<template>
  <v-card class="online-users-card" elevation="4">
    <v-card-title>
      <h2 class="section-title">
        <v-icon left>mdi-account-group</v-icon>
        Online Nutzer
      </h2>
      <v-spacer></v-spacer>
      <v-chip color="success" small>
        {{ users.length }} Online
      </v-chip>
    </v-card-title>
    <v-card-text>
      <v-list dense dark class="user-list pa-0" rounded>
        <v-list-item
          v-for="user in users"
          :key="user.userId"
          :class="['user-item', user.isActive ? 'user-active' : 'user-idle']"
        >
          <v-list-item-avatar>
            <v-icon :color="user.isActive ? 'success' : 'warning'">
              {{ user.role === 'admin' ? 'mdi-shield-account' : 'mdi-account' }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ user.userId }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ user.role }} - {{ formatLastActivity(user.lastActivity) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip
                  v-on="on"
                  :color="user.isActive ? 'success' : 'warning'"
                  x-small
                >
                  {{ user.isActive ? 'Aktiv' : 'Inaktiv' }}
                </v-chip>
              </template>
              <span>Verbunden seit: {{ formatConnectedTime(user.connectedAt) }}</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      
      <!-- User Statistics -->
      <v-card flat class="mt-3 pa-3" color="rgba(255, 255, 255, 0.1)" dark>
        <v-row>
          <v-col cols="4" class="text-center">
            <div class="user-stat-value">{{ stats.totalOnline }}</div>
            <div class="user-stat-label">Total Online</div>
          </v-col>
          <v-col cols="4" class="text-center">
            <div class="user-stat-value">{{ stats.activeUsers }}</div>
            <div class="user-stat-label">Aktiv</div>
          </v-col>
          <v-col cols="4" class="text-center">
            <div class="user-stat-value">{{ stats.adminCount }}</div>
            <div class="user-stat-label">Admins</div>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OnlineUsers',
  
  props: {
    users: {
      type: Array,
      default: () => []
    },
    stats: {
      type: Object,
      default: () => ({
        totalOnline: 0,
        activeUsers: 0,
        adminCount: 0
      })
    }
  },
  
  methods: {
    formatLastActivity(lastActivity) {
      if (!lastActivity) return 'Unbekannt';
      const now = new Date();
      const activity = new Date(lastActivity);
      const diffMs = now - activity;
      const diffMins = Math.floor(diffMs / 60000);
      
      if (diffMins < 1) return 'Gerade eben';
      if (diffMins < 60) return `Vor ${diffMins} Min.`;
      
      const diffHours = Math.floor(diffMins / 60);
      if (diffHours < 24) return `Vor ${diffHours} Std.`;
      
      return `Vor ${Math.floor(diffHours / 24)} Tagen`;
    },
    
    formatConnectedTime(connectedAt) {
      if (!connectedAt) return 'Unbekannt';
      return new Date(connectedAt).toLocaleString('de-DE');
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.2rem;
  font-weight: 500;
}

.online-users-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(20, 20, 20, 0.95) 100%);
}

.user-list {
  max-height: 300px;
  overflow-y: auto;
}

.user-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.user-item:last-child {
  border-bottom: none;
}

.user-active {
  background: rgba(76, 175, 80, 0.1);
}

.user-idle {
  background: rgba(255, 152, 0, 0.05);
}

.user-stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
}

.user-stat-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
}
</style>